import { render } from "./Return.vue?vue&type=template&id=6487287e&scoped=true"
import script from "./Return.vue?vue&type=script&lang=js"
export * from "./Return.vue?vue&type=script&lang=js"

import "./custom-return.scss?vue&type=style&index=0&id=6487287e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6487287e"]])

export default __exports__